"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQRCode = exports.encodeWifiConfig = void 0;
var qrcode_1 = __importDefault(require("qrcode"));
/**
 * Escape a tag value. Special characters are `,`, `\`, `;`, and `:` and will be prefixed by a backslash.
 *
 * @param value
 */
var escapeTagValue = function (value) {
    var n = value.replace(/[\\\;\:\,]/g, '\\$&');
    return n;
};
/**
 * Encodes a single tag, escaping special characters.
 *
 * @param tag
 * @param value
 * @param required
 *
 * @throws an Error if the tag is marked 'required' but the tag value is falsy
 *
 * @returns a string representing the tag if the value is defined, or `null` if the value is not defined
 */
var encodeTag = function (tag, value, required) {
    if (required && !value)
        throw new Error("Tag " + tag + " requires a value");
    return value ? tag + ":" + escapeTagValue(value) : null;
};
/**
 * Encodes WIFI config in a MeCard-like syntax that is accepted by iOS 11+ and Android 10+.
 * Special characters are automatically escaped.
 *
 * @param config
 *
 * @returns a string containing the encoded WIFI config
 */
var encodeWifiConfig = function (config) {
    var type = encodeTag('T', config.type);
    var ssid = encodeTag('S', config.ssid, true);
    var password = encodeTag('P', config.password);
    var hidden = encodeTag('H', config.hidden ? 'true' : '');
    var payload = [type, ssid, password, hidden].filter(Boolean).join(';');
    return "WIFI:" + payload + ";;";
};
exports.encodeWifiConfig = encodeWifiConfig;
/**
 * Create a QRCode wrapper that can export the QR code data in various formats.
 *
 * @param config
 * @param qrOptions
 */
var createQRCode = function (config, qrOptions) {
    var code = qrcode_1.default.create(exports.encodeWifiConfig(config), qrOptions || {});
    return new WifiQRWrapper(code);
};
exports.createQRCode = createQRCode;
/**
 * Wrapper around a QRCode that can export the code to multiple destinations.
 */
var WifiQRWrapper = /** @class */ (function () {
    function WifiQRWrapper(qrCode) {
        this.code = qrCode;
    }
    /**
     * Writes the QRCode to an HTML Canvas.
     *
     * @param element
     * @param opts
     *
     * @returns a Promise that resolves once the canvas is updated
     */
    WifiQRWrapper.prototype.toHtmlCanvas = function (element, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, qrcode_1.default.toCanvas(element, this.code.segments, opts)];
            });
        });
    };
    /**
     * Writes the QRCode to a file.
     *
     * @param path
     * @param opts
     *
     * @returns a Promise that resolves once the file is written
     */
    WifiQRWrapper.prototype.toFile = function (path, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, qrcode_1.default.toFile(path, this.code.segments, opts)];
            });
        });
    };
    /**
     * Writes the QRCode in PNG format to a writable stream.
     *
     * @param stream
     * @param opts
     *
     * @returns a Promise that resolves once the stream is complete
     */
    WifiQRWrapper.prototype.toPngStream = function (stream, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, qrcode_1.default.toFileStream(stream, this.code.segments, opts)];
            });
        });
    };
    /**
     * Gets a data URI that allows retrieval of the QR code.
     *
     * @param opts
     *
     * @returns a Promise that resolves once the data URI is generated
     */
    WifiQRWrapper.prototype.toDataUrl = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, qrcode_1.default.toDataURL(this.code.segments, opts)];
            });
        });
    };
    return WifiQRWrapper;
}());
